export default "__VITE_ASSET__vOC3mvOW__"